import { css } from 'styled-components';

/** @mixin overflowPaddingMixin */
/**
 * Adds padding style around auto overflowed components,
 * often used with `overflowAutoMixin`.
 *
 * @example
 * import { overflowAutoMixin, overflowPaddingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *      ${overflowAutoMixin}
 *      ${overflowPaddingMixin(
 *          spaceMixin('xs'),
 *          spaceMixin('md'),
 *          spaceMixin('xl'),
 *          spaceMixin('sm')
 *      )};
 * `;
 *
 * <Component>component vertical scrollable with overflow padding</Component>
 *
 * @method
 * @param {string} top - Top padding value.
 * @param {string} right - Right padding value.
 * @param {string} bottom - Bottom padding value.
 * @param {string} left - Left padding value.
 * @return {CSSObject}
 */
// Firefox handles bottom padding very strangely:
// https://stackoverflow.com/questions/29986977/firefox-ignores-padding-when-using-overflowscroll
// The workaround is to add a content spacer in place of padding.
export var overflowPaddingMixin = function overflowPaddingMixin(top, right, bottom, left) {
  return function () {
    return css(["padding:", " ", " 0 ", ";&:after{content:'';display:block;height:", ";}"], top, right, left, bottom);
  };
};